<div class="table-values">
  @if (showTextLiveWidget) {
    <div class="text-widget">
      @for (signal of chartSettings?.signals; track signal) {
        <div class="values-row">
          <span [innerHTML]="getLabelAndUnit(signal)" [title]="getLabelAndUnit(signal)" class="name d-block"></span>
          <span [innerHTML]="getValueOrFallback(signal)" class="value"></span>
        </div>
      }
    </div>
  }

  @if (showTextStaticWidget) {
    <div class="text-widget">
      @for (staticData of chartSettings?.staticData!; track staticData) {
        <div class="values-row">
          <span [innerHTML]="staticData" [title]="staticData" class="name d-block"></span>
          <span [innerHTML]="getStaticValue(staticData)" class="value"></span>
        </div>
      }
    </div>
  }

</div>
